import { createSelector } from "reselect";
import { isDevelopment } from "../../utils/assembly";
import {
  selectorStatusesWebsiteUrlsForOfflineUse,
  selectorWebsiteUrlsForOfflineUse
} from "@/shared/store";

export const selectorIsWebsiteDownloaded = createSelector(
  selectorWebsiteUrlsForOfflineUse,
  selectorStatusesWebsiteUrlsForOfflineUse,
  (urlsForOfflineUse, urlsStatuses) => {
    return urlsForOfflineUse.every((u) => {
      if (
        !urlsStatuses[u]
        && isDevelopment()
        && u?.includes("static/development/")
      ) {
        return true;
      }

      return urlsStatuses[u];
    });
  }
);
